import { ToggleButton, ToggleButtonGroup, styled } from '@mui/material'
import { Dropdown } from '@evocolabs/orkaui'
import React, { useState } from 'react'

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    margin: theme.spacing(0.5),
    border: 0,
    '&.Mui-disabled': {
      border: 0
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius
    }
  }
}))

type ToggleButtonGroupProps = {
  buttonInfo: { text: string; key: string }[]
  callback: (value: string) => void
}
const ToggleGroup = ({ buttonInfo = [], callback }: ToggleButtonGroupProps) => {
  const [alignment, setAlignment] = useState(buttonInfo[0].key || '')

  const toggleClick = (value) => {
    if (!value) return
    setAlignment(value)
    if (typeof callback === 'function') {
      callback(value)
    }
  }
  return (
    <>
      <StyledToggleButtonGroup
        size="small"
        value={alignment}
        sx={{
          '&': {
            width: '100%',
            display: { xs: 'none', md: 'flex' }
          }
        }}
        exclusive
        onChange={(_, value) => toggleClick(value)}
        aria-label="text alignment"
      >
        {buttonInfo.map((value) => (
          <ToggleButton
            value={value.key}
            key={value.key}
            color="standard"
            sx={{
              '&.MuiToggleButton-root.MuiToggleButton-standard:first-of-type': {
                ml: 0
              },
              '&.MuiToggleButton-root.MuiToggleButton-standard': {
                color: '#26201F',
                bgcolor: 'transparent',
                boxShadow: '0 0 0 1px #B8B6B5',
                borderRadius: '8px',
                textTransform: 'none',
                p: '11px 16px',
                fontWeight: 600,
                lineHeight: '26px',
                fontSize: '18px',
                fontFamily: 'Open Sans',
                letterSpacing: '-0.2px'
              },
              '&.MuiToggleButton-root.MuiToggleButton-standard.Mui-selected': {
                bgcolor: '#415670',
                color: '#FFFFFF'
              },
              '&.MuiToggleButton-root.MuiToggleButton-standard:hover:not(.Mui-selected)':
                {
                  bgcolor: 'transparent',
                  boxShadow: '0 0 0 1px #506A8A'
                },
              '&.MuiToggleButton-root.MuiToggleButton-standard.active': {
                bgcolor: '#30445E',
                color: '#FFFFFF'
              },
              '&.MuiToggleButton-root.MuiToggleButton-standard + &[type="button"]':
                {
                  ml: '16px'
                }
            }}
            aria-label="left aligned"
          >
            {value.text}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
      <Dropdown
        value={buttonInfo.find((i) => i.key === alignment)?.text}
        controlSx={{
          width: '100%',
          display: { xs: 'inline-flex', md: 'none' },
          '& > .MuiInputBase-root': {
            borderColor: '#30445E',
            '& > .MuiSelect-select[role="combobox"]': {
              bgcolor: '#EFF1F5',
              '.orkaui-select-text': {
                textAlign: 'left',
                fontWeight: '600'
              }
            }
          }
        }}
        onChange={(event) =>
          toggleClick(
            buttonInfo.find((i) => i.text === event.target?.value)?.key
          )
        }
        sx={{ display: { xs: 'flex', md: 'none' } }}
        choice={buttonInfo.map((i) => i.text)}
      ></Dropdown>
    </>
  )
}

export default ToggleGroup
